import { createSelector } from '@reduxjs/toolkit';

import { DEPRECIATION, DepreciationType } from '../../constants.ts';
import { selectOrder } from './orderSelectors.ts';
import { selectAllImprovements } from './propertyDataSelectors/improvementsSelectors.ts';

const selectOrderDepreciation = createSelector([selectAllImprovements], (improvements) => {
  const depreciationTypes = new Set<DepreciationType>();
  improvements.forEach((improvement) => {
    Object.entries(DEPRECIATION).forEach(([depreciation, { hasDepreciation }]) => {
      if (hasDepreciation(improvement)) depreciationTypes.add(depreciation as DepreciationType);
    });
  });

  return Array.from(depreciationTypes);
});

export const selectOrderHasFunctionalDepreciation = createSelector(
  [selectOrderDepreciation, selectOrder],
  (orderDepreciation, order) =>
    (order.depreciationSettings.enableFunctionalDepreciation &&
      orderDepreciation.includes('functional')) ??
    false,
);

export const selectOrderHasExternalDepreciation = createSelector(
  [selectOrderDepreciation, selectOrder],
  (orderDepreciation, order) =>
    (order.depreciationSettings.enableExternalDepreciation &&
      orderDepreciation.includes('external')) ??
    false,
);
